import { gql } from '@apollo/client';

export const GET_USER_STATS = gql`
  query userstats {
    userstats {
      total_posts
      total_featured
      total_replies
      total_views
    }
  }
`;

export const GET_TF_STATS = gql`
  query stats($days: Int!) {
    stats(days: $days) {
      authors
      posts
    }
  }
`;
